/**
 * Part of lead-popup logic, is needed to hide lead popup.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (lead) => {
      if (!lead || !lead.saveQuoteForLater || !lead.saveQuoteForLater.data) {
        return;
      }

      if (kasko.getState().input.previous_lead_data_id === lead.saveQuoteForLater.data.id) {
        return;
      }

      kasko.dispatchEvent('set-state-input', {
        previous_lead_data_id: lead.saveQuoteForLater.data.id,
        is_email_modal: false,
      });
    },
    { slice: 'lead' },
  );
};
